import { tabHeadingDictionary as tabKeywords } from "@core/global/global-country-dictionary";

export const setLevelTwoDatahandler = (data, currentTab, importerPerPage, exporterPerPage, logisticsPerPage, currentPage, secondLevelDropdownValue) => {
  let array = [];
  let viewAllPerPage = tabKeywords.importers === currentTab ? importerPerPage : tabKeywords.exporters === currentTab ? exporterPerPage : logisticsPerPage;
  let defaultPage = currentPage;
  let toPage = (defaultPage * viewAllPerPage) / secondLevelDropdownValue - 1;
  let fromPage = toPage - viewAllPerPage / secondLevelDropdownValue + 1;

  for (let i = fromPage; i <= toPage; i++) {
    if (!!data[i] && !!data[i].sub_data && !!data[i].sub_data.length) {
      data[i].sub_data.map((val, index) => {
        let obj = { ...val, ...data[i] };
        obj.key = data[i].key;
        obj.subKey = val.key;
        obj.total = data[i].total_value;
        obj.sno = index + 1;
        obj.parent_doc_count = data[i].doc_count;
        obj.parent_teu = !!data[i].teu && !!data[i].teu.value ? data[i].teu.value : data[i].teu;
        obj.parent_weight = !!data[i].weight && data[i].weight.value !== undefined && data[i].weight.value !== null && data[i].weight.value !== "" ? data[i].weight.value : data[i].weight;
        obj.parent_shipment_value = !!data[i].shipment_value && data[i].shipment_value.value !== undefined && data[i].shipment_value.value !== null && data[i].shipment_value.value !== "" ? data[i].shipment_value.value : data[i].shipment_value;
        obj.doc_count = val.inner_doc_count;
        obj.company_type = data[i].company_type;
        obj.teu = val.inner_teu;
        obj.weight = val.inner_weight;
        obj.shipment_value = val.inner_shipment_value;
        obj.showBorder = index + 1 === data[i].sub_data.length ? true : false;
        array.push(obj);
      });
    } else if (data[i]) {
      let obj = { ...data[i] };
      obj.key = data[i].key;
      obj.subKey = "NA";
      obj.total = data[i].total_value;
      obj.sno = 1;
      obj.parent_doc_count = data[i].doc_count;
      obj.parent_teu = !!data[i].teu && !!data[i].teu.value ? data[i].teu.value : data[i].teu;
      obj.parent_weight = !!data[i].weight && data[i].weight.value !== undefined && data[i].weight.value !== null && data[i].weight.value !== "" ? data[i].weight.value : data[i].weight;
      obj.parent_shipment_value = !!data[i].shipment_value && data[i].shipment_value.value !== undefined && data[i].shipment_value.value !== null && data[i].shipment_value.value !== "" ? data[i].shipment_value.value : data[i].shipment_value;
      obj.doc_count = data[i].doc_count;
      obj.company_type = data[i].company_type;
      obj.teu = !!data[i].teu && !!data[i].teu.value ? data[i].teu.value : data[i].teu;
      obj.weight = !!data[i].weight && data[i].weight.value !== undefined && data[i].weight.value !== null && data[i].weight.value !== "" ? data[i].weight.value : data[i].weight;
      obj.shipment_value = !!data[i].shipment_value && !!data[i].shipment_value.value ? data[i].shipment_value.value : data[i].shipment_value;
      array.push(obj);
    }
  }
  return array;
};

export const secondUIUEStyleHandler = (secondLevelData, uiTwoLevel, ueTwoLevel, ulTwoLevel, currentTab, importerPerPage, exporterPerPage, logisticsPerPage, totalUniqueImporter, totalUniqueExporter, totalUniqueLogistics, defaultPage, dataCount, viewAllPerPage, secondLevelDropdownValue) => {
  if (!!secondLevelData && !!secondLevelData.length && (uiTwoLevel || ueTwoLevel || ulTwoLevel)) {
    let val = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination select option");
    // val = document.querySelectorAll('.ui-ue-two-level-change .rdt_Pagination select option').length ? document.querySelectorAll('.ui-ue-two-level-change  .rdt_Pagination select option') : val
    if (!!val && !!val.length) {
      val[0].textContent = 5;
      val[1].textContent = 10;
      val[2].textContent = 20;
    }
    let range = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination span");
    // range = document.querySelectorAll('.lvl-two-table-container-route .rdt_Pagination span').length ? document.querySelectorAll('.lvl-two-table-container-route .rdt_Pagination span') : range
    if (!!range && !!range.length) {
      let perPage = tabKeywords.importers === currentTab ? importerPerPage : tabKeywords.exporters === currentTab ? exporterPerPage : logisticsPerPage;
      let toPage = (defaultPage * perPage) / secondLevelDropdownValue - 1;
      let fromPage = toPage - perPage / secondLevelDropdownValue + 1;
      range[1].textContent = `${fromPage + 1} - ${toPage + 1} of ${tabKeywords.importers === currentTab ? totalUniqueImporter : tabKeywords.exporters === currentTab ? totalUniqueExporter : totalUniqueLogistics}`;
    }
    let prevPage = document.querySelectorAll(".lvl-two-table-container #pagination-previous-page");
    // prevPage = document.querySelectorAll('.lvl-two-table-container-route #pagination-previous-page').length ? document.querySelectorAll('.lvl-two-table-container-route #pagination-previous-page') : prevPage
    if (!!prevPage && !!prevPage.length && defaultPage > 1) {
      prevPage[0].removeAttribute("disabled");
    }
    let nextPage = document.querySelectorAll(".lvl-two-table-container #pagination-next-page");
    nextPage = document.querySelectorAll(".lvl-two-table-container-route #pagination-next-page").length ? document.querySelectorAll(".lvl-two-table-container-route #pagination-next-page") : nextPage;
    if (!!nextPage && !!nextPage.length && defaultPage * (viewAllPerPage / secondLevelDropdownValue) >= dataCount) {
      // nextPage[0].setAttribute('disabled', true) // fall backto handle next pagination in ui ue 2 level-- arindam
    }
    let rows = document.querySelectorAll(".lvl-two-table-container .rdt_TableRow");
    // rows = document.querySelectorAll('.lvl-two-table-container-route .rdt_TableRow').length ? document.querySelectorAll('.lvl-two-table-container-route .rdt_TableRow') : rows
    if (!!rows && !!rows.length) {
      secondLevelData.forEach((item, index) => {
        if (!item.showBorder && !!rows[index] && !!rows[index].firstChild) {
          let firstChild = rows[index].firstChild;
          firstChild.style.setProperty("border-bottom", "none", "important");
        }
        if (!item.showBorder && !!rows[index] && !!rows[index] && currentTab === tabKeywords.logistics) {
          rows[index].firstChild.nextSibling.style.setProperty("border-bottom", "none", "important");
        }
      });
    }
    let pagination = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination");
    // pagination = document.querySelectorAll('.lvl-two-table-container-route .rdt_Pagination').length ? document.querySelectorAll('.lvl-two-table-container-route .rdt_Pagination') : pagination
    if (!!pagination && !!pagination.length && !!secondLevelData && secondLevelData.length < 8) {
      pagination[0].style.marginTop = -(48 * (10 - secondLevelData.length)) + 30 + "px";
    }
  }
};

export const TRADE_DIRECTIONS = {
  I: "import",
  E: "export",
};
